/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { string, array, func } from 'prop-types';
import classNames from 'clsx';

import BlackTieIcon from 'components/BlackTieIcon/BlackTieIcon';

import styles from './custom-input.scss';

/**
 * This is the CustomInput component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default class CustomInput extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    className: string,
    items: array,
    onClick: func,
    onRemove: func,
  };

  static defaultProps = {
    className: null,
    items: [],
    onClick: () => {},
    onRemove: () => {},
  };

  onRemove = (event, date) => {
    const { onRemove } = this.props;

    event.stopPropagation();

    onRemove(date);
  };

  renderItems = () => {
    const { items } = this.props;

    return items.map(date => (
      <div key={`date-${date}`} className={styles.item}>
        <span className={styles.text}>{date}</span>
        <button
          type="button"
          className={styles.remove}
          onClick={e => this.onRemove(e, date)}
        >
          <svg
            height="14"
            width="14"
            viewBox="0 0 20 20"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z" />
          </svg>
        </button>
      </div>
    ));
  };

  /**
   * Render CustomInput.
   *
   * @return {Object}
   */
  render() {
    const { className, onClick } = this.props;

    return (
      <div className={classNames(className, styles.wrapper)} onClick={onClick}>
        {this.renderItems()}
        <span className={styles.icon}>
          <BlackTieIcon icon="calendar" />
        </span>
      </div>
    );
  }
}
